import { loadScript, loadStyles } from 'utils/load_external'

const BingMapsApi = 'AiG804EvOUQOmDJV0kiOY8SSD0U1HirOAKucXLbAKTRy1XAVTaBDnO7FCty3X-n6'

const StylesURL =
  'https://cesium.com/downloads/cesiumjs/releases/1.55/Build/Cesium/Widgets/widgets.css'
const ScriptURL =
  'https://cesium.com/downloads/cesiumjs/releases/1.55/Build/Cesium/Cesium.js'

export function initCesiumApi() {
  if (window.cesiumApiReady) {
    dispatchReady()
    return
  }

  loadStyles(StylesURL)
  loadScript(ScriptURL, { onLoad, onError })
}

function onLoad() {
  window.cesiumApiReady = true

  Cesium.Ion.defaultAccessToken = document.querySelector(
    'meta[name="cesium-api-key"]'
  ).content
  Cesium.BingMapsApi.defaultKey = BingMapsApi

  dispatchReady()
}

function onError() {
  window.cesiumApiReady = false

  document.dispatchEvent(
    new Event('cesium_api:failed', { bubbles: true, cancellable: true })
  )
}

function dispatchReady() {
  document.dispatchEvent(
    new Event('cesium_api:ready', { bubbles: true, cancellable: true })
  )
}
